<template>
  <b-modal
    id="documentsModal"
    title="Данные заказчика"
    size="lg"
    ok-title="Сохранить"
    cancel-title="Отмена"
    cancel-variant="outline-secondary"
    :visible="isShow"
    @change="(val) => $emit('update:is-show', val)"
  >
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Статус</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="selectedStatus"
            :options="statusOptions"
            class="w-100"
            label="label"
            :reduce="val => val.value"
            @input="(val) => changeStatus(val)"
          />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <b-list-group class="mb-2">
          <b-list-group-item class="active">
            <b>Персональные данные</b>
          </b-list-group-item>
          <b-list-group-item class="">
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Номер:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b> {{ orderItem.msisdn }}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                ФИО:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b>{{ orderItem.fio }}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Контактный номер:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b> {{ orderItem.phone_number }}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Цена заказа:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b> {{ orderItem.price }}</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </div>
      <div class="col-12 col-md-6">
        <b-list-group class="mb-2">

          <b-list-group-item class="active">
            <b>Онлайн регистрация</b>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Фото с паспортом (Селфи):
              </b-col>
              <b-col cols="12" md="6" lg="6" class="modal-img">
                <viewer v-if="orderItem.selfie_passport" :options='options'>
                  <template>
                    <img v-auth-image="orderItem.selfie_passport" class="image">
                  </template>
                </viewer>
                <b v-else>Фото не загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Паспорт (Строна А):
              </b-col>
              <b-col cols="12" md="6" lg="6" class="modal-img">
                <viewer v-if="orderItem.passport_a" :options='options'>
                  <template>
                    <img v-auth-image="orderItem.passport_a" class="image">
                  </template>
                </viewer>
                <b v-else>Фото не загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
          <b-list-group-item>
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Паспорт (Строна B):
              </b-col>
              <b-col cols="12" md="6" lg="6" class="modal-img">
                <viewer v-if="orderItem.passport_b" :options='options'>
                  <template>
                    <img v-auth-image="orderItem.passport_b" class="image">
                  </template>
                </viewer>
                <b v-else>Фото не загружено</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </div>
      <div class="col-12">
        <b-list-group class="mb-2">
          <b-list-group-item class="active">
            <b>Доставка</b>
          </b-list-group-item>
          <b-list-group-item class="">
            <b-row>
              <b-col cols="12" md="6" lg="6">
                Адрес:
              </b-col>
              <b-col cols="12" md="6" lg="6">
                <b v-if="orderItem.address"> {{ orderItem.address }}</b>
                <b v-else>Нет адрес доставки</b>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import {
  BModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
} from 'bootstrap-vue'
import axios from 'axios'
import 'viewerjs/dist/viewer.css'
import useJwt from '@/auth/jwt/useJwt'

const authHeader = `Bearer ${localStorage.getItem('accessToken')}`
axios.defaults.headers.common.Authorization = authHeader

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BListGroup,
    BListGroupItem,
    vSelect,
  },
  methods: {
    changeStatus(selected) {
      useJwt.orderNUmberChangeStatus(this.orderItem.id, {
        status: selected,
      }).then(() => {
        this.$emit('update:selectedStatus', selected)
        this.$emit('refresh-table')
      }).catch(error => {
        console.log(error.response.data)
      })
    },
  },
  data() {
    return {
      options: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: false,
        transition: true,
        fullscreen: true,
        keyboard: true,
      },
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    orderItem: {
      type: Object,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    selectedStatus: {
      type: [Number, String, null],
      default: 0,
      required: true,
    },
  },
  updated() {
  },
}
</script>

<style scoped>
.modal-img img {
  cursor: pointer;
  width: 50%;
}
</style>
